module.exports = __webpack_public_path__ + "img/Instagram_logo.e0b4a772.png";